import React from 'react';
import { ImageViewProps, FileType } from './types';
import { StyledPageWrapper } from './StyledComponents';

const ImageView = <T extends FileType>({
  file,
  render,
  onLoad,
}: ImageViewProps<T>) => {
  const Image = (
    <StyledPageWrapper>
      <img src={file.url} onLoad={onLoad} />
    </StyledPageWrapper>
  );

  return render ? render(Image, file) : Image;
};

export default ImageView;
